import React, { useState, createContext, useMemo } from 'react';
import PropTypes from 'prop-types';

const DashboardContext = createContext();
const ServiceNowIntegrationContext = createContext();

const DashboardProvider = props => {
  const [dashboard, setDashboard] = useState(null);
  // isConfigured: null = not yet checked, false = checked and not configured, true = configured
  const [snIntegration, setSnIntegration] = useState({
    isConfigured: null,
    testResult: {}
  });

  // Memoize the context values
  const dashboardValue = useMemo(() => [dashboard, setDashboard], [dashboard]);
  const snIntegrationValue = useMemo(() => [snIntegration, setSnIntegration], [snIntegration]);

  return (
    <DashboardContext.Provider value={dashboardValue}>
      <ServiceNowIntegrationContext.Provider value={snIntegrationValue}>
        {props.children}
      </ServiceNowIntegrationContext.Provider>
    </DashboardContext.Provider>
  );
};

DashboardProvider.propTypes = {
  children: PropTypes.node
};

export { DashboardContext, ServiceNowIntegrationContext, DashboardProvider };
